import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import { hanldeSecureless } from '../middleware/hanldeSecureless';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { StatusV2 } from '../../../../../requests-module/src';
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight';
import store from '@/store/BookingStore';
import { startGlobalPollingFlight } from '@/composables/pollingFlightController';

export const userInfoStep = new FunnelStep({
    name: RouteNameEnum.UserInfoV2,
    dependencies: [],
    init: async () => {
        console.log('init(): Initializing UserInfoV2 Page - if logged in - refresh');
        const response = await BookingFunnelService.refreshBookingOptions()
        console.log('init(): Initializing UserInfoV2 Page - if logged out, just a a login form.');

        if ('error' in response) {
            throw new Error('Error with api')
        }
        if (checkIsPackageFlight(store.getters.getBooking)) {
            startGlobalPollingFlight(store.getters.getBooking.boReference);
        }

        if (response.status == StatusV2.SUCCESS) {
            return '/paid'
        }

        return false
    },
    hasToBeLoggedIn: false

});